
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

var globalThis = require('globalthis')() // returns native globalThis if compliant

@Component({
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
    }),
  },
})
export default class PopUpDialog extends Vue {
  private dialog: boolean = true

  created() {
    if (globalThis.devEnvironment) this.dialog = false
    else this.dialog = true
  }
}
